import { api } from "../utils/api";
import type { DBChainModeActivationJob } from "@KassaroAB/shared/types/chainModeActivationJob";
import type { ChainId, ChainModeActivationJobId, StoreId } from "@KassaroAB/shared/types/ids";

export const getChainModeActivationJobsApi = (
  chainId: ChainId,
): Promise<DBChainModeActivationJob[]> => {
  return api.get(`chains/${chainId}/chainModeActivationJobs`);
};

export const getChainModeActivationJobApi = (
  chainId: ChainId,
  chainModeActivationJobId: ChainModeActivationJobId,
): Promise<DBChainModeActivationJob> => {
  return api.get(
    `chains/${chainId}/chainModeActivationJobs/${chainModeActivationJobId}`,
  );
};

export const startChainModeActivationJobApi = (
  chainId: ChainId,
  storeId?: StoreId,
): Promise<DBChainModeActivationJob> => {
  return api.post(`chains/${chainId}/chainModeActivationJobs`, {
    ...(storeId ? { storeId } : {}),
  });
};

export const retryChainModeActivationJobApi = (
  chainId: ChainId,
  chainModeActivationJobId: ChainModeActivationJobId,
): Promise<DBChainModeActivationJob> => {
  return api.post(
    `chains/${chainId}/chainModeActivationJobs/${chainModeActivationJobId}/retry`,
    {},
  );
};
